import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useTrainingReport(trainingId: string) {
  return useQuery({
    queryKey: ['training-reports', trainingId],
    queryFn: () => api.get(`/api/training-reports/training/${trainingId}`),
    enabled: !!trainingId,
  })
}

export function useMemberReport(userId: string) {
  return useQuery({
    queryKey: ['member-reports', userId],
    queryFn: () => api.get(`/api/training-reports/member/${userId}`),
    enabled: !!userId,
  })
}

async function downloadCsv(path: string, fileName: string): Promise<void> {
  const res = await api.raw(path)
  if (!res.ok) throw new Error('Export failed')
  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.click()
  URL.revokeObjectURL(url)
}

export function useExportTrainingCsv(trainingId: string) {
  return {
    exportCsv: () =>
      downloadCsv(
        `/api/training-reports/training/${trainingId}/export`,
        `training-report-${trainingId}.csv`,
      ),
  }
}

export function useExportSkillCheckCsv(trainingId: string) {
  return {
    exportSkillCheckCsv: () =>
      downloadCsv(
        `/api/training-reports/training/${trainingId}/skill-check-export`,
        `skill-check-${trainingId}.csv`,
      ),
  }
}
